import { Link } from "@material-ui/core";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { pURLs } from "../utils/parameters";

export function Help() {
    return (
        <HomeWrapper>
            <body style={{ margin: 10 }}>
                <article>
                    <header>
                        <h1 class="page-title">SignaMed</h1>
                    </header>
                    <div class="page-body">
                        <h3 >Bienvenido a la página de soporte de la aplicación SignaMed.</h3>
                        <p >Si no encuentras aquí lo que quieras saber escríbenos un e-mail a speechsigns@gmail.com</p>
                        <h3>Página en mantenimiento</h3>
                        <Link onClick={() => window.open(pURLs.help)} key={'permissions'}>
                            Clica aquí para ir a la página de info actualizada
                        </Link>
                    </div>
                </article>
            </body>
        </HomeWrapper>

    )
}